import { useSelector } from 'react-redux'
import { getKillswitchFlagsError, getKillswitchFlagsLoaded } from 'src/selectors/usBankKillswitch'

/**
 * Whether the killswitch rows can be trusted. Before the first successful load, or after a failed
 * refresh, "no global row" would read as "processing is running" — so callers must treat the
 * status as unknown and block anything that depends on it.
 */
export const useKillswitchStatusKnown = (): boolean => {
  const isLoaded = useSelector(getKillswitchFlagsLoaded)
  const flagsError = useSelector(getKillswitchFlagsError)

  return isLoaded && flagsError === null
}
